let SkeletonBackgroundColor = /*#__PURE__*/function (SkeletonBackgroundColor) {
  SkeletonBackgroundColor["LIGHT"] = "light";
  SkeletonBackgroundColor["DARK"] = "dark";
  return SkeletonBackgroundColor;
}({});

export { SkeletonBackgroundColor };
//# sourceMappingURL=backgroundColor.js.map
